/**
 * get all cats in one country for pie
 * @param  {array} arr     the output from cntsInOneCatForLine function
 * @return {array}         array in above format 
 */
/*
[{
  name: "Categories",
  max; 122,
  colorByPoint: true,
  data: [
    {
      name: "Animals",
      y: [56.33, 65, 25, ...],
      drilldown: "Animals"
    }, 
    {
      name: "Coffee",
      y: [24.03, 23, 3...],
      drilldown: "Coffee"
    }, 
  ...
  ]
}]
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.catsInOneCntForBar = catsInOneCntForBar;

function catsInOneCntForBar(arr) {

  var output = [];

  output.push({
    name: "Categories",
    max: 0,
    colorByPoint: true,
    data: []
  });

  var max = 0;
  arr.forEach(function (obj) {

    obj['data'].forEach(function (d) {
      max = Math.max(max, d);
    });

    output[0].data.push({
      name: obj['name'],
      y: obj['data'],
      drilldown: obj['name']
    });
  });

  output[0].max = max;

  return output;
}
//# sourceMappingURL=data:application/json;base64,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